<template>
  <SectionTemplate
    title="数千款好莱坞级3D数字人 谁来出镜由你决定"
    desc="海量3D数字人涵盖各年龄段、族裔与风格，无论是专业正式还是亲切自然，总有一款适合你"
  >
    <div class="container">
      <div class="characters">
        <ContentCharacterCard
          class="avatar-card"
          v-for="digitalHuman in calList"
          :key="digitalHuman.id"
          :data="digitalHuman"
          target="_blank"
          @change="onChange($event, digitalHuman)"
          @mobile-preview-start="handleMobilePreviewStart"
          :collect="false"
          :preview="false"
          :mobile-preview-first="true"
          :active-mobile-preview-id="activeMobilePreviewId"
        >
        </ContentCharacterCard>
      </div>
      <SSButton variant="border-white-middle" @click="handleGoCharacter" class="show-more-btn">
        查看更多数字人
        <ArrowRight class="text-[22px]" />
      </SSButton>
    </div>
  </SectionTemplate>
</template>

<script setup lang="ts">
import type { Character } from '~/api/interface/character';
import { getCharacterList } from '~/api/module/character';
import ArrowRight from '~/assets/svg/icon-arrow-right.svg?component';
import SSButton from '~/design/components/buttons/base.vue';
import SectionTemplate from '~/design/widgets/landing-section/cn-template.vue';

provideResourceLocation({
  source: SOURCE.CHARACTER,
});

const handleGoCharacter = () => {
  navigateTo(`/characters`, { open: { target: '_blank' } });
};

const calList = ref<Character[]>();
const activeMobilePreviewId = ref<number | null>(null);

const handleMobilePreviewStart = (characterId: number) => {
  activeMobilePreviewId.value = characterId;
};

const fetchCharacterList = async () => {
  const res = await getCharacterList({
    group_id: 1,
    page: 1,
    page_size: 20,
    many: 1,
    o: '-score',
  });

  // deepOmit(res, ['look'])

  // res.data?.results?.forEach((item) => {
  //   item.query_star = import.meta.client // 标记这些数据是否查询过star
  // })

  calList.value = res.data?.results || [];

  return res;
};

// const { calList, status } = useStarPatchList(list, 3)

const onChange = ([key, value]: [string, Character], data: Character) => {
  const item: any = calList.value?.find(item => item.id === data.id);
  if (item) {
    item[key] = value;
  }
};

onMounted(async () => {
  await fetchCharacterList();
});
</script>

<style lang="scss" scoped src="./pc.scss"></style>
<style lang="scss" scoped src="./mobile.scss"></style>
